import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

const Whychooseusa = () => {
  return (
    <div className="whychooseusa p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              Why Choose Us as Your Custom Software Development Company?
            </h2>
            <p>
              By choosing our software development services, you are not just hiring a team of professionals, you are associating yourselves with industry experts dedicated to transforming ideas into successful projects.
            </p>
            <p>
              Here's why you should choose us as your reliable custom software development agency:
            </p>
          </Col>
        </Row>
        <Row className="h-100 choose_padd">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <p><strong>Expertise & Experience:</strong> Our software developers bring a wealth of expertise, navigating the intricacies of the framework to craft smooth and efficient software solutions.</p>
            <p><strong>Communication:</strong>We use agile approaches and transparent communication to gain real-time insights while encouraging collaborative development engagement. </p>
            <p><strong>Scalability:</strong>We provide software with adaptable designs, embracing cloud technology for easy growth while guaranteeing alignment with operational demands.</p>
            <p><strong>Technical Proficiency:</strong>Our developers excel in the latest frameworks, showcasing technical mastery for complex software projects.</p>
            <p><strong>Cost-Effectiveness:</strong> We maximize efficiency through coding and agile workflows, ensuring cost-effectiveness without compromising software quality.</p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Book A Free Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
            <StaticImage
              src="../../images/services-usa/custom/Why-Choose.webp"
              alt="Custom Software Development Company"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={910}
              height={650}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Whychooseusa;
